import React from "react";

import { Inbox } from "supercell-frontend-base/src/components/inbox";

import styles from "./styles.modules.scss";

type AppViewProps = {
    commander: unknown;
    localization: LocalizationConfig;
    routes: Route[];
};

export const AppView = (props: AppViewProps) => (
    <div className={`app ${styles.app}`}>
        <Inbox {...props} />
    </div>
);
